export default __webpack_public_path__ + "static/media/dog-high-five.119527ba.png";